import * as svg from "../../../assets/user-gear-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const UserGearIcon = iconBuilder(svg, "UserGearIcon", "0 0 20 20");
